// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1MznO","header":"ReportDetails_header__3m3Vp","title":"ReportDetails_title__UOG0x","left":"ReportDetails_left__1DQag"};